import {useState, useEffect, useRef, useContext} from 'react';
import {Utils} from '../Utils';
import {AppContext} from '../App';
import {BackButton} from './BackButton';
import {OP_CO_MAP} from '../Constants';
import './CoursePage.css';

const PALETES = [
	['#845ec2', '#d65db1'],
	['#ff6f91', '#ff9671'],
	['#845ec2', '#2c73d2'],
	['#0081cf', '#0089ba'],
	['#008e9b', '#008f7a'],
	['#334c6b', '#007292'],
	['#009aa4', '#24c09c'],
	['#334c6b', '#505a81'],
	['#716895', '#9475a5'],
	['#b882b0', '#dc8fb8']
];

export function CoursePage({courses})
{
	const closure = useContext(AppContext);
	const recommendText = Utils.tr('COURSE_RECOMMEND');
	const recommendText2 = Utils.tr('COURSE_RECOMMEND2');
	const contactText = Utils.tr('COURSE_CONTACT_US');
	const contactText2 = Utils.tr('COURSE_CONTACT_US_2');
	const contactText3 = Utils.tr('COURSE_CONTACT_US_3');
	
	const onContactBtnClick = () =>
	{
		closure.dispatch({type: 'push', page: 'contact'});
	}

	const onBackBtnClick = () =>
	{
		//closure.dispatch({type: 'pop'});
		window.history.back();
		if(!isNaN(courseInfo.selectedCourse))
		{
			if(selectedLiRef.current)
			{
				selectedLiRef.current.classList.remove('is-selected');
				selectedLiRef.current = null;
			}
			setCourseInfo((prev) =>
			{
				return {...prev, selectedCourse: NaN};
			});
		}
	};
	const divRef = useRef();
	const selectedLiRef = useRef();
	const [courseInfo, setCourseInfo] = useState({});

	useEffect(() =>
	{
		const div = divRef.current;
		const onClick = (evt) => 
		{
			let target = evt.currentTarget;
			let i = Number(target.getAttribute('data-course'));
			let h = 0;
			let p = target;
			while(p && p !== div)
			{
				h += p.offsetTop;
				p = p.offsetParent;
			}

			if(selectedLiRef.current)
			{
				const prev = selectedLiRef.current;
				prev.classList.remove('is-selected');
			}
			target.classList.add('is-selected');
			selectedLiRef.current = target;
			
			setCourseInfo((prev) =>
			{
				return {selectedCourse: i, bound:h};
			});
		};

		const lis = div.getElementsByTagName('li');
		let len = lis.length;
		while(len--)
		{
			lis[len].addEventListener('click', onClick);
		}

		const courseBoxes = div.getElementsByClassName('course-box');
		const len2 = courseBoxes.length;
		let k;
		
		for(k = 0; k < len2; k++)
		{
			let elm = courseBoxes[k];
			setTimeout(() =>
			{
				elm.classList.add('is-shown');
			}, 300 * k + 200);
		}

		return () =>
		{
			let len = lis.length;
			while(len--)
			{
				lis[len].removeEventListener('click', onClick);
			}

			// len = courseBoxes.length;
			// while(len--)
			// {
			// 	courseBoxes[len].classList.remove('is-shown');
			// }
		};

	}, [courses]);

	useEffect(() =>
	{
		if(!isNaN(courseInfo.selectedCourse))
		{
			setTimeout(() =>
			{
				const info = courseInfoRef.current;
				if(info)
				{
					info.classList.add('is-active');
				}
				
			}, 20);	
		}
	}, [courseInfo]);

	const courseInfoRef = useRef();
	const onCourseInfoClose = () =>
	{
		const info = courseInfoRef.current;
		const onTransEnd = () =>
		{
			info.removeEventListener('transitionend', onTransEnd);
			if(selectedLiRef.current)
			{
				selectedLiRef.current.classList.remove('is-selected');
				selectedLiRef.current = null;
			}
			setCourseInfo((prev) =>
			{
				return {...prev, selectedCourse: NaN};
			});
		};
		info.addEventListener('transitionend', onTransEnd);
		info.classList.remove('is-active');
	};

	const opList = Utils.tr('OCCUPATION_LIST');
	const coList = Utils.tr('COURSES_LIST');
	const opDesc = Utils.tr('OCCUPATION_DESC');
	const coDesc = Utils.tr('COURSES_DESC');
	return (
		<>
			<ul className="courses-list" ref={divRef}>
				{
					courses.map((course, key) =>
					{
						const numRec = OP_CO_MAP[course].filter(v => v === 1).length;
						const recText = numRec > 1 ? (numRec + ' ' + recommendText) : recommendText2;
						return (
							<div className="box course-box" key={key}>
								<div className="columns">
								<div className="column is-4">
									<div className="c-image"> 
										<figure className="image">
							  				<img alt="ocupation" className="is-rounded" src={process.env.PUBLIC_URL + "/images/occupations/" + course + ".png"} />
										</figure>
									</div>
								</div>
								<div className="column is-8">
									<div className="c-body">
										<h5 className="title is-5"><span>{opList[course]}</span></h5>
										<p className="intro">{opDesc[course]}</p>
										<h6><span>{recText}</span></h6>
										<ul className="recommended-courses-list">
										{
											OP_CO_MAP[course].map((v, key) => 
											{
												if(v !== 1) return null;
												let j = key % PALETES.length;
												let bg = {
													background: 'linear-gradient(to right top, ' + PALETES[j][0] + ', ' +  PALETES[j][1] + '), url(' + process.env.PUBLIC_URL + '/images/noise.png)',
													backgroundBlendMode: 'multiply'
												};

												return (<li key={"couse-" + key} style={bg} data-course={key}>
													<span>{coList[key]}</span>
												</li>);
											}).filter(v => v !== null)
										}
										</ul>
									</div>
								</div>
							</div>
						</div>);
					})
				}

			</ul>
			{
				(!isNaN(courseInfo.selectedCourse) && 
				<div className="box course-info" ref={courseInfoRef} style={{top: courseInfo.bound, background: 'linear-gradient(to right top, ' + PALETES[courseInfo.selectedCourse % PALETES.length][0] + ', ' +  PALETES[courseInfo.selectedCourse % PALETES.length][1] + '), url(' + process.env.PUBLIC_URL + '/images/noise.png)'}}>
					<div className="close-bar"><button className="delete is-large" onClick={onCourseInfoClose}></button></div>
					<h5>{coList[courseInfo.selectedCourse]}</h5>
					<p>{coDesc[courseInfo.selectedCourse]}</p>
				</div>)
			}
			<div className="box contact-box">
				<div className="columns">
					<div className="column is-8">
						<h5>{contactText}</h5>
						<p>{contactText3}</p>
						<div className="contact-btn-row">
							<button className="button is-primary style-btn is-size-4" onClick={onContactBtnClick}>
								<i className="fa fa-phone"></i>
								<span>{contactText2}</span>
							</button>
						</div>
					</div>
				</div>
			</div>
			<div className="navigation">
				<div className="block has-text-centered">
					<BackButton onClick={onBackBtnClick} />
				</div>
			</div>
		</>
	);
}
